import React, { useContext } from 'react';
import { MessageInputContext } from '../MessageInput/MessageInputContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import templatesAPI from './TemplatesAPI';
import IconButton from './IconButton';
import IconTemplateSave from 'venuescanner-js/react/components/Objects/Icons/IconTemplateSave';
import templateQueries from './queries';

const SaveMessageAsTemplate = ({ buildTemplate }) => {
  const { setErrorMessage } = useContext(MessageInputContext);
  const queryClient = useQueryClient();
  const createTemplateMutation = useMutation(
    async template => templatesAPI.create(template),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(templateQueries.keyFactories.all());
      },
      onError: error => {
        setErrorMessage(error.message);
      },
    },
  );

  const saveTemplate = async () => {
    const template = buildTemplate();
    if (template.name) {
      await createTemplateMutation.mutate(template);
    }
  };
  return (
    <IconButton
      onClick={saveTemplate}
      icon={
        <IconTemplateSave
          className='template__save'
          width='20'
          height='20'
          aria-hidden='true'
          focusable='false'
        />
      }
      text='Save as template'
      style={{
        textTransform: 'none',
        color: 'unset',
      }}
    />
  );
};

export default SaveMessageAsTemplate;
